(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('honeybadger-js')) :
  typeof define === 'function' && define.amd ? define(['exports', 'honeybadger-js'], factory) :
  (global = global || self, factory(global.HoneybadgerVue = {}, global.Honeybadger));
}(this, (function (exports, Honeybadger) { 'use strict';

  Honeybadger = Honeybadger && Object.prototype.hasOwnProperty.call(Honeybadger, 'default') ? Honeybadger['default'] : Honeybadger;

  var HoneybadgerVue = {
    install: function install (Vue, options) {
      var this$1 = this;

      if (Vue.config.debug) {
        console.log(("Honeybadger configured with " + (options.apiKey)));
      }
      var honeybadger = Honeybadger.configure(options);
      Vue.$honeybadger = honeybadger;
      Vue.prototype.$honeybadger = Vue.$honeybadger;
      var chainedErrorHandler = Vue.config.errorHandler;
      var extractContext = function (vm) {
        var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options ||
          vm.constructor.options : vm || {};
        var name = options.name || options._componentTag;
        var file = options.__file;
        return {
          isRoot: vm.$root === vm,
          name: name,
          props: options.propsData,
          parentVnodeTag: options._parentVnode ? options._parentVnode.tag : undefined,
          file: file
        }
      };
      Vue.config.errorHandler = function (error, vm, info) {
        honeybadger.notify(error, { context: { vm: extractContext(vm), info: info } });
        if (typeof chainedErrorHandler === 'function') {
          chainedErrorHandler.call(this$1.Vue, error, vm, info);
        }
      };
    }
  };

  exports.default = HoneybadgerVue;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=honeybadger-vue.umd.js.map
